import { IMutationsMock } from "./mutations.types";

export const mockMutations = (): IMutationsMock => ({
  SET_CURRENT_LOCALE: jest.fn(),
  SET_CURRENT_LOCATION: jest.fn(),
  SET_SIGNED_IN: jest.fn(),
  SET_LOGGED_USER: jest.fn(),
  SET_DISCLAIMER: jest.fn(),
  SET_USERS_GUIDE: jest.fn(),
  SET_COUNTRY_CONFIG: jest.fn(),
  SET_CASH_COUNTRY_CONFIG: jest.fn(),
  SET_COUNTRIES_PAGE: jest.fn(),
  SET_ASSIGNABLE_ADAPTERS: jest.fn(),
  SET_CURRENCIES_PAGE: jest.fn(),
  SET_SOLCUSTOMER_CURRENCIES: jest.fn(),
});
